import { Controller } from "@hotwired/stimulus";
// mostly stolen from below but slightly modified to handle the context and args better
// https://github.com/stimulus-use/stimulus-use/blob/main/src/use-debounce/use-debounce.ts
// https://github.com/stimulus-use/stimulus-use/blob/main/docs/use-debounce.md

class DebounceController extends Controller {
  static debounces = [];
}

const defaultWait = 200;

export const debounce = (fn, wait = defaultWait) => {
  let timeoutId = null;

  return function () {
    const args = Array.from(arguments);
    const context = this;
    const params = args.map((arg) => arg.params);

    const callback = () => {
      args.forEach((arg, index) => (arg.params = params[index]));
      return fn.apply(context, args);
    };
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(callback, wait);
  };
};

export const useDebounce = (composableController, options) => {
  const controller = composableController;
  const constructor = controller.constructor;

  constructor.debounces.forEach((func) => {
    if (typeof func === "string") {
      controller[func] = debounce(controller[func], options?.wait);
    }

    if (typeof func === "object") {
      const { name, wait } = func;
      if (!name) return;
      controller[name] = debounce(controller[name], wait || options?.wait);
    }
  });
};
